module.exports = __webpack_public_path__ + "img/SIDEBAR_Abfahrk.d0abb51e.svg";